import Logo from "../../../../assets/icons/samtree-logo.png"

const Privacy = () => {
    return (
        <div className="bg-black h-screen w-screen grid grid-rows-[1fr_9fr]">
            <div className="flex justify-center items-center max-h-[300px]">
                <img src={Logo} alt="Logo" className="max-w-[200px] max-h-[200px]" />
            </div>
            <div className='text-center'>
                <h1 className="text-white md:text-5xl text-3xl font-bold h-1/4 flex justify-center items-center">Samtree Privacy Policy</h1>
                <p className="text-white md:text-xl text-lg h-3/4">
                    All WearOS made in the SamTree is a watch face created by WatchFaceStudio, not collecting user data, and all data is fully encrypted.
                </p>
            </div>

        </div>
    )
}

export default Privacy;